var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 18",
    style: {
      enableBackground: "new 0 0 14 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7433",
    d: "M1,16c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V6c0-1.1-0.9-2-2-2H3C1.9,4,1,4.9,1,6V16z M13,1h-2.5 L9.8,0.3C9.6,0.1,9.4,0,9.1,0H4.9C4.6,0,4.4,0.1,4.2,0.3L3.5,1H1C0.4,1,0,1.4,0,2s0.4,1,1,1h12c0.6,0,1-0.4,1-1S13.6,1,13,1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.27cd193ead309adfede6aba3974fd68d.svg";
export { ForwardRef as ReactComponent };